"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Icon from "./icon.js";
export const BagIcon = React.forwardRef(function BagIcon(props, ref) {
    return (_jsx(Icon, Object.assign({ ref: ref }, props, { children: _jsx("path", { d: "M3 7v13.125C3 21.161 3.895 22 5 22h14c1.105 0 2-.84 2-1.875V7H3zm5-.498V6a4 4 0 0 1 8 0v.502" }) })));
});
export default BagIcon;
//# sourceMappingURL=bag.js.map